import { ControllerVersion } from '@bymason/controller-api-hooks';
import { FeatureFlag } from '@bymason/controller-api-hooks';
import { createContext, Dispatch, SetStateAction } from 'react';

export type FetchAccountMetadata = () => void;
export type UpdateControllerVersion = (optInControllerVersion: ControllerVersion) => void;
export type SetShowNewControllerTooltip = Dispatch<SetStateAction<boolean>>;

interface IGlobalState {
  devicesCount?: number | null;
  groupsCount?: number | null;
  projectsCount?: number | null;
  selectedControllerVersion?: ControllerVersion | null;
  showNewControllerTooltip: boolean;
  featureFlags: FeatureFlag[];
  setShowNewControllerTooltip: SetShowNewControllerTooltip;
  fetchCounts: FetchAccountMetadata;
  updateSelectedControllerVersion: UpdateControllerVersion;
}

const initialContext: IGlobalState = {
  devicesCount: undefined,
  groupsCount: undefined,
  projectsCount: undefined,
  selectedControllerVersion: undefined,
  showNewControllerTooltip: false,
  featureFlags: [],
  setShowNewControllerTooltip: (): void => {
    throw new Error('The method "setShowNewControllerTooltip" has not been properly set in global context.');
  },
  fetchCounts: (): void => {
    throw new Error('The method "fetchCounts" has not been properly set in global context.');
  },
  updateSelectedControllerVersion: (): void => {
    throw new Error(
      'The method "updateSelectedControllerVersion" has not been properly set in global context.'
    );
  },
};

export default createContext<IGlobalState>(initialContext);
